import { Component, Input } from '@angular/core';
import { Experience, ExperienceShort } from '../../../services/interfaces/experiences';
import { Region } from '../../../services/interfaces/region';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-regions',
  standalone: false,
  templateUrl: './regions.component.html',
  styleUrl: './regions.component.scss'
})
export class RegionsComponent {

  constructor(private route: ActivatedRoute,private router:Router){}
  @Input() regionName:string|null=null;

  @Input() region: Region | undefined;
  @Input() experience: Experience | undefined;  

  experiences: ExperienceShort[] = [];
  experienceNum: number| undefined = 195;

  responsiveOptionsExperience = [
    {
      breakpoint: '1470px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '1000px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '800px',
      numVisible: 2,
      numScroll: 2,
    },
  ];

  ngOninit():void{
    this.route.paramMap.subscribe(params=>{
      this.regionName
      = params.get('label');
    })

    
  }


  linkToExperience(experienceId: string, experienceName: string) : void{

  }
}
